import React from 'react';

var SvgPasswordHidden = function SvgPasswordHidden(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.383 7.258c-.463.43-.75 1.042-.75 1.725 0 1.306 1.06 2.367 2.367 2.367.696 0 1.32-.3 1.756-.78l.754.686c-.619.68-1.51 1.114-2.51 1.114-1.87 0-3.387-1.517-3.387-3.387 0-.978.413-1.855 1.075-2.472z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 6.611q-.322.001-.614.082c-.272.074-.552-.086-.626-.358-.075-.271.086-.552.357-.626q.424-.116.883-.117c1.87 0 3.387 1.517 3.387 3.387q0 .433-.108.844c-.072.272-.35.434-.623.363-.272-.072-.435-.351-.363-.624q.075-.277.074-.583c0-1.307-1.06-2.368-2.367-2.368",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.263 5.36c.135.247.044.556-.203.691-1.733.947-2.732 2.601-3.069 3.56-.093.265-.384.405-.65.312s-.405-.385-.312-.65c.399-1.136 1.537-3.021 3.542-4.117.247-.135.557-.044.692.204",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.025 4.563c.606-.168 1.261-.265 1.975-.265 4.2 0 6.394 3.326 6.971 4.975.093.266-.047.557-.312.65-.266.093-.557-.047-.65-.313-.505-1.44-2.422-4.292-6.009-4.292-.619 0-1.183.084-1.703.228-.271.075-.552-.084-.627-.355-.075-.272.084-.553.355-.628",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.447 3.15c.2-.2.522-.2.722 0l9.782 9.782c.2.199.2.522 0 .721-.2.2-.522.2-.721 0l-9.783-9.783c-.199-.199-.199-.522 0-.72",
    clipRule: "evenodd"
  }));
};
SvgPasswordHidden.displayName = "PasswordHidden";

export { SvgPasswordHidden as S };
